import React from 'react'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import IconsList from 'components/IconsList'
import {getIcons} from 'utils/utils'
import {createCard, updateCard, deleteCard} from 'modules/modules/actions'

class ListConfig extends React.PureComponent {
    constructor(props) {
        super(props)

        this.change = false
        const icons = getIcons()

        this.state = {
            entity: props.entities.length ? this.props.entities[0].id : null,
            icon: props.card ? props.card.icon : icons[0],
            name: props.card ? props.card.label : this.props.entities.length ? this.props.entities[0].singular : '',
            createTable: props.cardId || this.props.entities.length ? false : true
        }

    }

    createCard = () => {
        this.props.createCard({
            entityId: this.state.createTable ? 0 : this.state.entity,
            label: this.state.name,
            icon: this.state.icon,
            moduleId: this.props.currentModule
        }, this.props.type)

        this.props.handleClose()
    }

    deleteCard = () => {
        this.props.deleteCard(this.props.cardId)
        this.props.handleClose()
    }

    updateCard = () => {
        this.props.updateCard({
            id: this.props.cardId,
            label: this.state.name,
            icon: this.state.icon,
            moduleId: this.props.currentModule
        }, this.props.type)

        this.props.handleClose()
    }

    handleSelect = (e) => {
        if (this.change) {
            this.setState({
                entity: e.target.value
            })
        } else {
            this.setState({
                entity: e.target.value,
                name: this.props.entities.find(item => item.id === e.target.value).singular
            })
        }
    }

    handleChange = (e) => {
        this.change = true
        this.setState({ name: e.target.value })
    }

    handleCheck = (e) => {
        if (e.target.checked) {
            this.setState({
                createTable: e.target.checked,
                entity: null,
                name: this.change ? this.state.name : ''
            })
        } else {
            this.setState({
                createTable: e.target.checked,
                entity: this.props.entities[0].id,
                name: this.change ? this.state.name : this.props.entities[0].singular
            })
        }
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <DialogTitle>
					{intl.formatMessage({id: this.props.cardId ? "main.edit_list" : "main.create_lst"})}
                </DialogTitle>
                <DialogContent>
                    <TextField variant="standard"
                        value={this.state.name}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "main.label_list_card"})}
                        sx={{
							width: '100%',
							marginBottom: '20px'
						}}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            maxLength: global.NAME_MAX_LENGTH
                        }}
                    />
                    {!!this.props.entities.length && !this.props.cardId &&
                        <FormControl style={{marginBottom: '10px', width: '100%'}} variant="standard">
                            <InputLabel shrink={true}>
                                {intl.formatMessage({id: "main.select_table"})}
                            </InputLabel>
                            <Select
                                value={this.state.entity ? this.state.entity : ''}
                                onChange={this.handleSelect}
                                disabled={this.state.createTable}
                            >
                                {this.props.entities.map((item, index) =>
                                    <MenuItem key={index} value={item.id}>{item.singular}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    {!this.props.cardId &&
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.createTable}
                                    onChange={this.handleCheck}
                                    disabled={!this.props.entities.length}
                                />
                            }
                            label={intl.formatMessage({id: "main.list_card_create_table"})}
                            style={{marginBottom: '10px'}}
                        />
                    }
                    <IconsList
                        onClick={(icon) => this.setState({ icon })}
                        icon={this.state.icon}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.cardId &&
                        <Button variant="contained"
                            onClick={this.deleteCard}
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    {this.props.cardId ?
                        <Button variant="contained"
                            disabled={
                                (this.state.name === this.props.card.label &&
                                this.state.icon === this.props.card.icon) ||
                                !this.state.name ||
                                this.state.name.replace(/\s/g, '') === ''
                            }
                            onClick={this.updateCard}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_save"})}
                        </Button>
                        :
                        <Button variant="contained"
                            disabled={!this.state.name.length || this.state.name.replace(/\s/g, '') === ''}
                            onClick={this.createCard}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_create"})}
                        </Button>
                    }
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default connect(null, {createCard, updateCard, deleteCard})(injectIntl(ListConfig))
